import React from 'react';
import { Badge } from '@components/atoms/Badge';

export type SlotStatusBadgeVariant = 'missing' | 'failed' | 'required' | 'optional' | 'dispositioned';

const LABELS: Record<SlotStatusBadgeVariant, string> = {
  missing: 'MISSING',
  failed: 'UPLOAD FAILED',
  required: 'REQUIRED',
  optional: 'OPTIONAL',
  dispositioned: 'DISPOSITIONED',
};

const BADGE_VARIANTS: Record<
  SlotStatusBadgeVariant,
  'error' | 'warning' | 'default' | 'secondary' | 'primary'
> = {
  missing: 'error',
  failed: 'warning',
  required: 'default',
  optional: 'secondary',
  // Sprint 12, story-051 (U72). Blue/neutral — distinct from both green success and red gap.
  dispositioned: 'primary',
};

/**
 * Sprint 11, story-042 (U77). "MISSING" / "FAILED" / "REQUIRED" / "OPTIONAL" pill, per
 * docs/ux/story-042-design.md's component breakdown.
 */
export const SlotStatusBadge: React.FC<{ variant: SlotStatusBadgeVariant }> = ({ variant }) => (
  <Badge size="sm" variant={BADGE_VARIANTS[variant]}>
    {LABELS[variant]}
  </Badge>
);

export default SlotStatusBadge;
